import _ from "lodash";

const filterCentralPharmacies = (manufacturer, pharmacyList, centralFillList) => {
  if (manufacturer === "merck") {
    // Merck implemented a partial central fill block;
    // only pharmacies with the manufacturer set to 'merck' are blocked
    return _.filter(
      pharmacyList,
      (cp) => !centralFillList.some((b) => b.value === cp.pid && b.manufacturer === manufacturer)
    );
  } else {
    // Manufacturer implemented a full central fill block; manufacturer check is here for forward compatibility
    return _.filter(
      pharmacyList,
      (cp) =>
        !centralFillList.some((b) => {
          return b.value === cp.pid && (!b.manufacturer || b.manufacturer === manufacturer);
        })
    );
  }
};

export default filterCentralPharmacies;
